const DB_NAME = 'trip-tracker';
const STORE = 'pings';
const DB_VERSION = 1;

let dbPromise = null;

function openDb() {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    const r = indexedDB.open(DB_NAME, DB_VERSION);
    r.onupgradeneeded = () => {
      const db = r.result;
      if (!db.objectStoreNames.contains(STORE)) {
        const s = db.createObjectStore(STORE, { keyPath: 'client_id' });
        s.createIndex('captured_at', 'captured_at');
      }
    };
    r.onsuccess = () => resolve(r.result);
    r.onerror = () => reject(r.error);
  });
  return dbPromise;
}

function tx(mode) {
  return openDb().then((db) => db.transaction(STORE, mode).objectStore(STORE));
}

export async function enqueue(ping) {
  const store = await tx('readwrite');
  return new Promise((resolve, reject) => {
    const r = store.put(ping);
    r.onsuccess = () => resolve();
    r.onerror = () => reject(r.error);
  });
}

export async function peekAll(limit = 500) {
  const store = await tx('readonly');
  return new Promise((resolve, reject) => {
    const r = store.index('captured_at').getAll(null, limit);
    r.onsuccess = () => resolve(r.result);
    r.onerror = () => reject(r.error);
  });
}

export async function remove(clientIds) {
  if (!clientIds.length) return;
  const store = await tx('readwrite');
  await Promise.all(clientIds.map(id => new Promise((res, rej) => {
    const r = store.delete(id);
    r.onsuccess = () => res();
    r.onerror = () => rej(r.error);
  })));
}

export async function count() {
  const store = await tx('readonly');
  return new Promise((resolve, reject) => {
    const r = store.count();
    r.onsuccess = () => resolve(r.result);
    r.onerror = () => reject(r.error);
  });
}
